import { PageMeta, JsonLd } from '@/components/feature/SeoComponents';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestSection from './components/LatestSection';
import GenreSection, { HanjuSection } from './components/GenreSection';
import RankingSection from './components/RankingSection';
import ExploreSection from './components/ExploreSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '老子影视网 - 电视剧大全 全集播放',
  description: '老子影视网电视剧大全全集播放，涵盖国产剧全集、韩剧全集、最新电视剧免费在线观看，高清画质不缓冲，追剧必备。',
  url: 'https://www.laoziys.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '老子影视网',
    url: 'https://www.laoziys.com',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.laoziys.com',
      },
    ],
  },
};

export default function HomePage() {
  return (
    <>
      <PageMeta
        title="老子影视网 | 电视剧大全 全集播放 电视剧在线 国产剧全集 韩剧全集 | 最新电视剧 免费观看 高清 不缓冲"
        description="老子影视网电视剧大全全集播放，涵盖国产剧全集、韩剧全集、最新电视剧免费在线观看，高清画质不缓冲，追剧必备。"
        keywords="电视剧大全,全集播放,电视剧在线,国产剧全集,韩剧全集,最新电视剧,免费观看,高清,不缓冲,老子影视网"
        canonicalUrl="https://www.laoziys.com"
      />
      <JsonLd data={homeJsonLd} />

      <main>
        <HeroSection />
        <CategoryNav />
        <LatestSection />
        <GenreSection />
        <HanjuSection />
        <RankingSection />
        <ExploreSection />

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-950">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              追剧不停，精彩不断
            </h2>
            <p className="text-foreground-400 text-sm md:text-base mb-8">
              老子影视网持续更新最新最热的电视剧资源，高清画质不缓冲，让追剧成为一种享受。国产剧全集、韩剧全集、日剧台剧美剧一网打尽！
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/category/all"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>开始追剧
              </a>
              <a
                href="/about"
                className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer border border-white/15"
              >
                <i className="ri-information-line mr-2"></i>了解更多
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}